import React from 'react';
import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';

import PageHeader from '@common/PageHeader';
import styled from '@emotion/styled';
import { Container, Card, Spacer } from '@styles';

const StyledCookieSection = styled.section`
  width: 100%;
  color: var(--darkText);

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  a {
    color: var(--darkText);

    text-decoration: underline;
  }

  ul {
    margin-left: 20px;
  }
`;

const RenderBody = ({ home }) => {
  const title = home.title;
  const split = home.updated.split('-');
  const actualText = home.text;
  const icon = home.icon;

  return (
    <>
      <PageHeader
        title={RichText.asText(title)}
        subtitle={'Last updated: ' + split[1] + '/' + split[2] + '/' + split[0]}
        imageUrl={icon.url}
        imageAlt={icon.alt}
      />
      <Spacer break2 />
      <StyledCookieSection>
        <Container normal>
          <Card>{RichText.render(actualText)}</Card>
        </Container>
      </StyledCookieSection>
    </>
  );
};

export default ({ data }) => {
  const doc = data.prismic.allTermss.edges.slice(0, 1).pop();

  if (!doc) return null;
  return <RenderBody home={doc.node} />;
};

export const query = graphql`
  {
    prismic {
      allTermss {
        edges {
          node {
            title
            updated
            text
            icon
          }
        }
      }
    }
  }
`;
